'use strict';

var processInclude = require('app_custom_vinfast_ui/util');

$(document).ready(function() {
    processInclude(require('./global/customMain'));
});


